const requestEndPoint = {
  create: `bonusLeave/createBonusLeave`,
  edit: `bonusLeave/updateBonusLeave`,
};

import { DATE_FORMAT_V2_FULL, isInteger, handleMessagesAPI, isNumberValue, isNumeric, isValidValue, countDecimals } from "@/utils";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "AddBonusLeave",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },

    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      fetching: false,
      // handle show modal
      decorators: {
        staffs: [
          "staffs",
          {
            initialValue: this.mappingFormDataName(this.formData),
            // initialValue: this.formData,
            rules: [
              {
                required: true,
                message: "Staff is required",
              },
            ],
          },
        ],
        leaveHour: [
          'leave_hour',
          {
            initialValue: this.handleFormatNumVal(this.formData.leaveHour),
            rules: [
              {
                required: true,
                message: 'Leave Hour is required',
              },
              {
                validator: (rule, value, callback) =>
                  this.handleValidationHour(rule, value, callback, 'Leave hour', {
                    type: 'numeric',
                    from: 0,
                    to: 200,
                    isDecimal: true,
                    rangeFrom: true,
                    rangeTo: false,
                  }),
              },
            ],
          },
        ],
        note: [
          "note",
          {
            initialValue: this.formData.description,
          },
        ],
        dateApplied: [
          "date_applied",
          {
            initialValue: this.formData.applyDate,
            rules: [
              {
                required: true,
                message: "Date Applied is required",
              },
              // {
              //   validator: (rule, value, callback) =>
              //     this.handleValidation(rule, value, callback, "Date Applied", {
              //       type: "dateTime",
              //     }),
              // },
            ],
          },
        ],
        dateExpired: [
          "date_expired",
          {
            initialValue: this.formData.expireDate,
            rules: [
              {
                required: true,
                message: "Date Expired is required",
              },
              {
                validator: (rule, value, callback) =>
                  this.handleValidation(rule, value, callback, "Date Expired", {
                    type: "dateTime",
                  }),
              },
            ],
          },
        ],
      },
      form: this.$form.createForm(this, { name: "BonusLeaveInputForm" }),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 19 },
        layout: "horizontal",
      },

      // page search
      page: 1,
      // size search
      size: 30,
      searchValue: "",
      employeeListFilter: [],
    };
  },
  computed: {
    ...mapState({
      employeeList: (state) => state.filters.employeeList,
      mostRecentTimeSheetApproved: (state) => state.advance.mostRecentTimeSheetApproved,
      timeServer: (state) => state.application.timeServer,
    }),
  },
  created() {
    this.$store.dispatch("advance/getMostRecentTimeSheetApproved");
  },
  methods: {
    handleFormatNumVal(val) {
      if (val) {
        val = val.toFixed(2);
      }

      return val;
    },

    onSearch(value) {
      if (!value || !value.trim() || value.trim().length <= 2) return;

      this.searchValue = value;
      this.fetching = true;

      this.page = 1;
      this.size = 30;
      this.$store
        .dispatch("filters/getEmployeeList", value)
        .then(() => {
          this.employeeListFilter = this.employeeList;
          this.handleStaffsPagination();
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },

    handleScrollStaffs(e) {
      let needSearch = false;

      const { target } = e;
      const scrollTop = Math.ceil(target.scrollTop);
      if (scrollTop >= target.scrollHeight - target.offsetHeight) {
        this.page = this.page + 1;
        needSearch = true;
      }

      if (scrollTop == 0) {
        this.page = this.page - 1 >= 1 ? this.page - 1 : 1;
        needSearch = true;
      }

      if (needSearch) {
        setTimeout(() => {
          this.handleStaffsPagination();
        }, 1000);
      }
    },

    handleStaffsPagination() {
      let filterData = this.employeeList;
      let { page, size } = this;
      let skip = (page - 1) * size;
      if (skip >= filterData.length) {
        return;
      }

      let takeFrom = skip + 1;
      let takeTo = takeFrom + size;
      filterData = filterData.slice(takeFrom - 1, takeTo - 1);
      this.employeeListFilter = filterData;
    },

    mappingFormDataName(record) {
      return record.displayNames.length ? record.displayNames[0] : [];
    },

    handleOk(callback) {
      let result = false;
      this.form.validateFields((error, values) => {
        if (!error) {
          let payload = {
            id: this.formData.id,
            employeeId: this.formData.employeeId,
            leaveHour: parseFloat(values.leave_hour),
            description: values.note,
            applyDate: moment(values.date_applied).format("DD/MM/YYYY"),
            expireDate: moment(values.date_expired).format("DD/MM/YYYY"),
            createBy: this.formData.createBy,
            modifiedBy: this.formData.modifiedBy,
            modifiedDate: this.formData.modifiedDate,
          };

          if (this.isEdit) {
            payload.username = this.formData.usernames;
          } else {
            payload.usernames = [...values.staffs];
          }
          this.requestApi(payload, this.isEdit, callback);
          result = false;
        } else {
          callback(false, this.isEdit);
          result = false;
        }
      });

      return result;
    },

    requestApi(payload, isEdit, callback) {
      let endPoint = "";
      if (isEdit) {
        endPoint = requestEndPoint.edit;
      } else {
        endPoint = requestEndPoint.create;
      }

      this.$store
        .dispatch(endPoint, payload)
        .then((res) => {
          handleMessagesAPI(res);
          const { code } = res;
          if (code == 200) {
            callback(true, isEdit);
            this.form.resetFields();
          }
        })
        .catch((error) => {
          handleMessagesAPI(error.response.data);
          callback(false, isEdit);
        });
    },

    handleValidation(rule, value, callback, field, validateParams = {}) {
      if (!value) {
        callback();
      }

      if (validateParams.type !== "dateTime") {
        const isDecimal = validateParams.isDecimal;
        if (
          !isValidValue(value, isDecimal, 3) ||
          (validateParams.type == "numeric" && !isNumberValue(value, isDecimal, 3))
        ) {
          callback(`${field} is invalid`);
        }
      }

      switch (field) {
        case "Date Expired":
          this.handleExpiredDateValid(rule, value, callback);
          break;
        case "Leave Day":
          this.handleRangeVal(rule, value, callback, field, validateParams);
          break;

        default:
          break;
      }

      callback();
    },


    handleValidationHour(rule, value, callback, field, validateParams) {
      if (value) {
        const { from, to, isDecimal } = validateParams;
        if (!isNumeric(value) || value == 0) {
          callback(`${field} is invalid`);
        }
        if (!isDecimal && !isInteger(value)) {
          callback(`${field} is integer`);
        }
        const formatNumber = Number(value);

        if (formatNumber < from || formatNumber > to) {
          callback(`${field} in range ${from}-${to}`);
        }
        if (isDecimal && countDecimals(formatNumber) > 2) {
          callback("Invalid duration (ex: 0.50, 1.00 , 1.50, 2.10, ...) ");
        }
      }
      callback();
    },

    handleExpiredDateValid(rule, value, callback) {
      const dateApplied = this.form.getFieldsValue(["date_applied"]);
      if (value && dateApplied.date_applied) {
        if (dateApplied.date_applied.isAfter(moment(value, "DD/MM/YYYY").endOf("day"))) {
          callback("Apply date must be less than Expired date");
        }
      }
      callback();
    },

    handleRangeVal(rule, value, callback, field, validateParams) {
      // eslint-disable-next-line no-debugger
      // debugger
      const { from, to, isDecimal } = validateParams;
      let formatVal = null;
      if (isDecimal) {
        formatVal = parseFloat(value);
      } else {
        formatVal = parseInt(value);
      }

      let validFrom = false;
      if (validateParams?.rangeFrom) {
        validFrom = formatVal <= from;
      } else {
        validFrom = formatVal < from;
      }

      let validTo = false;
      if (validateParams?.rangeTo) {
        validTo = formatVal >= to;
      } else {
        validTo = formatVal > to;
      }

      if (validFrom || validTo) {
        callback(`${field} in range ${from.toFixed(2)}-${to.toFixed(2)}`);
      }

      callback();
    },

    handleDisabledApplyDate(date) {
      const { mostRecentTimeSheetApproved } = this;
      const expiredDate = this.form.getFieldValue("date_expired");
      return (
        (expiredDate && moment(date).isAfter(moment(expiredDate).endOf("day"))) ||
        moment(date).isBefore(moment(mostRecentTimeSheetApproved, DATE_FORMAT_V2_FULL).add(1, "days"))
      );
    },

    handleDisabledExpireDate(date) {
      const applyDate = this.form.getFieldValue("date_applied");
      return (
        (applyDate && moment(date).isBefore(moment(applyDate))) ||
        moment(date).isBefore(moment(this.timeServer, "DD/MM/YYYY").startOf("day"))
      );
    },
  },
  mounted() { },
  destroyed() { },
};
